export default "/kiban/_next/static/images/twitter-4648c094ebfb2101f46ae5b626933645.png";